import { render, staticRenderFns } from "./DataTableCellMobile.vue?vue&type=template&id=be5d47d6&"
import script from "./DataTableCellMobile.vue?vue&type=script&lang=ts&"
export * from "./DataTableCellMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports